import React, { createContext, useContext, useMemo } from "react";

export const YearlyContext = createContext();

export function YearlyProvider({ children, biddingClosed }) {
  const data = useMemo(() => {
    return {
      biddingClosed,
    };
  }, [biddingClosed]);

  return (
    <YearlyContext.Provider value={data}>{children}</YearlyContext.Provider>
  );
}

export const useYearlyContext = () => useContext(YearlyContext);
